export const getPriceVariantsIds = items => {
  const priceVariantsIds = items.flatMap(item => {
    var _item$priceVariants;
    return (((_item$priceVariants = item.priceVariants) == null ? void 0 : _item$priceVariants.variants) || []).map(priceVariant => priceVariant.variantId);
  }).filter(Boolean);
  const priceVariantsIdsWithoutDuplicates = new Set(priceVariantsIds);
  return [...priceVariantsIdsWithoutDuplicates];
};
export const createDisplayedPriceVariants = (priceVariants, priceVariantsMap) => {
  return priceVariants.reduce((priceVariantsArr, priceVariant) => {
    const priceVariantsDTO = priceVariantsMap[priceVariant.variantId];
    if (priceVariantsDTO) {
      priceVariantsArr = [...priceVariantsArr, {
        id: priceVariant.variantId,
        revision: priceVariantsDTO.revision,
        name: priceVariantsDTO.name,
        priceInfo: priceVariant.priceInfo
      }];
    }
    return priceVariantsArr;
  }, []);
};
export const getAllItemsPriceVariants = (items, populationLevel) => {
  if (populationLevel != null && populationLevel.priceVariants) {
    return items.reduce((priceVariantsArr, item) => {
      var _item$priceVariants2;
      return [...priceVariantsArr, ...(((_item$priceVariants2 = item.priceVariants) == null ? void 0 : _item$priceVariants2.variants) || [])];
    }, []);
  }
  return items.reduce((priceVariantsArr, item) => {
    var _item$priceVariants3;
    return [...priceVariantsArr, ...(((_item$priceVariants3 = item.priceVariants) == null ? void 0 : _item$priceVariants3.variants) || [])];
  }, []);
};
//# sourceMappingURL=priceVariants.js.map